<template>
  <div>
    <div class="d-flex justify-end">
      <v-btn
        class="primary-button ml-2"
        depressed
        @click="showFilter = !showFilter"
      >
        {{ showFilter ? 'Fechar filtros' : 'Filtros' }}
      </v-btn>
    </div>

    <v-expand-transition>
      <div v-if="showFilter">
        <div class="my-2 d-flex justify-end align-center">
          <v-text-field
            v-model="filter.search"
            placeholder="Pesquise pelo nome do padrão, nome do equipamento ou identificação do equipamento"
            class="primary-input mt-4"
            outlined
            style="max-width: 700px"
            hide-details
          ></v-text-field>
          <v-btn
            class="ma-0 primary-button ml-2"
            depressed
            @click=";(page = 1), list()"
          >
            Filtrar
          </v-btn>
        </div>
      </div>
    </v-expand-transition>

    <v-data-table
      :headers="headers"
      :items="patterns"
      class="main-table"
      hide-default-footer
      :items-per-page="pageSize"
      :loading="loading"
      :header-props="headerProps"
      hide-default-header
    >
      <template #header="{ props, on }">
        <thead>
          <tr>
            <th
              class="text-center"
              v-for="header in props.headers"
              :key="header.value"
            >
              <div>
                <v-hover v-slot="{ hover }">
                  <div>
                    <span>{{ $t(header.text) }}</span>
                    <v-icon
                      v-if="
                        hover &&
                        header.value != 'data-table-select' &&
                        header.value != 'actions' &&
                        header.value != 'checkbox'
                      "
                      color="white"
                      class="mx-2"
                      @click="on.sort(header.value)"
                    >
                      {{
                        props.options.sortBy.includes(header.value)
                          ? `mdi-chevron-down`
                          : `mdi-chevron-up`
                      }}
                    </v-icon>
                  </div>
                </v-hover>
              </div>
            </th>
          </tr>
        </thead>
      </template>
      <template #[`item.name`]="{ item }">
        {{ item.name }}
      </template>

      <template #[`item.propertyCode`]="{ item }">
        {{ item.propertyCode }}
      </template>

      <template #[`item.model`]="{ item }">
        {{ item.model }}
      </template>

      <template #[`item.manufacturer`]="{ item }">
        {{ item.manufacturer }}
      </template>

      <template #[`item.serialNumber`]="{ item }">
        {{ item.serialNumber }}
      </template>

      <template #[`item.expirationDate`]="{ item }">
        <div class="d-flex flex-column align-center">
          <span>{{ formatDate(item.expirationDate) }}</span>
          <v-chip
            v-if="isExpired(item.expirationDate)"
            x-small
            color="error"
            dark
            class="mt-1"
          >
            Vencido
          </v-chip>
        </div>
      </template>
    </v-data-table>

    <div class="pagination">
      <div class="item-pagination block-one">
        <v-menu bottom offset-y>
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              v-bind="attrs"
              v-on="on"
              class="btn"
              depressed
              color="#C0C0C0"
              small
            >
              qtd: {{ pageSize }}
            </v-btn>
          </template>
          <v-list>
            <v-list-item
              v-for="(size, i) in sizes"
              :key="i"
              @click="pageSize = size"
            >
              <v-list-item-title>{{ size }}</v-list-item-title>
            </v-list-item>
          </v-list>
        </v-menu>
        <div class="registros" v-if="totalItensOnPage">
          <span> 1 - {{ totalItensOnPage }} de {{ totalItems }} </span>
        </div>
      </div>

      <div class="item-pagination block-two">
        <v-pagination
          class="pagination-item"
          v-model="page"
          :length="totalPages"
          :total-visible="9"
        ></v-pagination>
      </div>
    </div>
  </div>
</template>

<script>
import ApiService from '../../../../../services/ApiService'
import moment from 'moment'

export default {
  name: 'borrowedPatternTable',

  data() {
    return {
      showFilter: false,
      patterns: [],
      pageSize: 10,
      sizes: [10, 25, 50, 180],
      totalItems: 4,
      totalItensOnPage: 4,
      totalPages: 1,
      page: 1,
      loading: false,
      filter: {
        page: 1,
        pageSize: 10,
      },
      apiService: new ApiService(),
      headerProps: {
        sortByText: 'Ordenar por',
      },
      headers: [
        { text: '', align: 'center', value: '', sortable: false },
        {
          text: 'Instituição',
          align: 'center',
          value: 'institution.name',
        },
        { text: 'Padrão', align: 'center', value: 'name' },
        {
          text: 'Código Patrimônio',
          align: 'center',
          value: 'equipment.propertyCode',
        },
        {
          text: 'Modelo',
          align: 'center',
          value: 'equipment.model',
        },
        {
          text: 'Fabricante',
          align: 'center',
          value: 'equipment.manufacturer',
        },
        {
          text: 'Nº Série',
          align: 'center',
          value: 'equipment.serialNumber',
        },
        {
          text: 'Validade',
          align: 'center',
          value: 'expirationDate',
        },
      ],
    }
  },

  created() {
    this.filter.institutionId = JSON.parse(
      localStorage.getItem('institution')
    ).id
    this.list()
  },

  methods: {
    list() {
      this.loading = true
      this.apiService
        .get('calibration/v2/pattern/borroweds', this.filter)
        .then((response) => {
          this.loading = false
          this.patterns = response.content.data
          this.totalItems = response.content.pager.totalItems
          this.totalPages = response.content.pager.totalPages
        })
        .catch(() => {
          this.loading = false
        })
    },

    isExpired(date) {
      if (!date) return false
      return moment().isAfter(moment(date), 'day')
    },

    formatDate(date) {
      const options = { year: 'numeric', month: '2-digit', day: '2-digit' }
      return new Date(date).toLocaleDateString('pt-BR', options)
    },

    viewItem(item) {
      console.log('Visualizar item', item)
    },
  },

  watch: {
    page() {
      this.filter.page = this.page
      this.list()
    },

    pageSize() {
      this.filter.pageSize = this.pageSize
      this.list()
    },
  },
}
</script>

<style></style>
